module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', {
    attrs: {
      "href": "/user/userTrackList"
    }
  }, [_vm._v("学员跟踪记录")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("添加跟踪记录")])], 1)], 1), _vm._v(" "), _c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "model": _vm.formValidate,
      "rules": _vm.ruleValidate,
      "label-width": 90
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID",
      "prop": "uid"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": _vm.uidReadonly,
      "maxlength": 10,
      "disabled": _vm.disable
    },
    model: {
      value: (_vm.formValidate.uid),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "uid", _vm._n($$v))
      },
      expression: "formValidate.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名",
      "prop": "nickname"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "placeholder": "只读",
      "disabled": _vm.disable
    },
    model: {
      value: (_vm.formValidate.nickname),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "nickname", $$v)
      },
      expression: "formValidate.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问",
      "prop": "adviserName"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "placeholder": "只读",
      "disabled": _vm.disable
    },
    model: {
      value: (_vm.formValidate.adviserName),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "adviserName", $$v)
      },
      expression: "formValidate.adviserName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学导",
      "prop": "studyAdviserName"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "placeholder": "只读",
      "disabled": _vm.disable
    },
    model: {
      value: (_vm.formValidate.studyAdviserName),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "studyAdviserName", $$v)
      },
      expression: "formValidate.studyAdviserName"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.$route.query.id) ? _c('Row', [_c('Col', {
    attrs: {
      "sm": 22,
      "md": 18
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "历史跟踪记录"
    }
  }, [_c('Table', {
    attrs: {
      "size": "small",
      "columns": _vm.userTrackRecordColumns,
      "data": _vm.userTrackRecordList
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 22,
      "md": 18
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "内容",
      "prop": "content"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 10
      }
    },
    model: {
      value: (_vm.formValidate.content),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "content", $$v)
      },
      expression: "formValidate.content"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "ghost": "",
      "size": "small",
      "loading": _vm.aiLoading,
      "disabled": _vm.aiLoading
    },
    on: {
      "click": _vm.handleAiMarkdown
    }
  }, [_vm._v("AI 处理")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "8px",
      "color": "#999",
      "font-size": "12px"
    }
  }, [_vm._v("将通话/听记原文清洗为结构化 Markdown")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系日期"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "clearable": false
    },
    on: {
      "on-change": _vm.nextTimeDateChange
    },
    model: {
      value: (_vm.formValidate.nextTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "nextTimeDate", $$v)
      },
      expression: "formValidate.nextTimeDate"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系人"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.formValidate.nextHandlerId),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "nextHandlerId", _vm._n($$v))
      },
      expression: "formValidate.nextHandlerId"
    }
  }, _vm._l((_vm.nextHandler), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [(_vm.trackType == '' || _vm.trackType == null) ? _c('Form-item', {
    attrs: {
      "label": "记录属性",
      "prop": "traceType"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formValidate.traceType),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "traceType", $$v)
      },
      expression: "formValidate.traceType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("新注册学生")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("分配记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "21"
    }
  }, [_vm._v("试听课记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "31"
    }
  }, [_vm._v("成交记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "41"
    }
  }, [_vm._v("交接记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "51"
    }
  }, [_vm._v("绑定记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "61"
    }
  }, [_vm._v("上课跟进记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "71"
    }
  }, [_vm._v("转介绍跟进记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "99"
    }
  }, [_vm._v("其他")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v("注册备注")])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formValidate')
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "跟踪记录内容",
      "width": "720",
      "mask-closable": false
    },
    model: {
      value: (_vm.contentVisible),
      callback: function($$v) {
        _vm.contentVisible = $$v
      },
      expression: "contentVisible"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "12px"
    }
  }, [_c('Radio-group', {
    attrs: {
      "type": "button",
      "size": "small"
    },
    on: {
      "on-change": _vm.switchContentView
    },
    model: {
      value: (_vm.contentViewMode),
      callback: function($$v) {
        _vm.contentViewMode = $$v
      },
      expression: "contentViewMode"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "markdown"
    }
  }, [_vm._v("Markdown")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "raw",
      "disabled": !_vm.contentRawText
    }
  }, [_vm._v("原文")])], 1), _vm._v(" "), (!_vm.contentRawText) ? _c('span', {
    staticStyle: {
      "margin-left": "8px",
      "color": "#999",
      "font-size": "12px"
    }
  }, [_vm._v("无原始内容")]) : _vm._e()], 1), _vm._v(" "), (_vm.contentViewMode === 'markdown') ? _c('div', {
    ref: "contentExportArea",
    staticClass: "track-md track-md-dialog",
    domProps: {
      "innerHTML": _vm._s(_vm.contentHtml)
    }
  }) : _c('pre', {
    ref: "contentExportArea",
    staticClass: "track-raw-dialog"
  }, [_vm._v(_vm._s(_vm.contentRawText))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "loading": _vm.exportImageLoading,
      "disabled": _vm.exportImageLoading || (_vm.contentViewMode === 'markdown' ? !_vm.contentHtml : !_vm.contentRawText)
    },
    on: {
      "click": _vm.exportContentPng
    }
  }, [_vm._v("导出 PNG")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.contentVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-390d9e29","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/UserTrackEdit.vue
// module id = 1757
// module chunks = 8